import React from 'react'
import { PostElement } from 'lib/core/data/blog/post/types'
import { PostTile } from '../PostTile'
import { Wrapper } from './components/Styled'

interface Props {
  title?: string
  posts: Array<PostElement | undefined> // TODO: fix this type, should be "posts?: PostElement[]"
  isFeatured?: boolean
}

export const PostsGrid: React.FC<Props> = ({ title, posts, isFeatured = false }) => {
  return (
    <Wrapper>
      <div className='posts-grid'>
        {posts?.map(post => {
          const {
            post_id: id,
            list_image: image,
            url_key: slug,
            title,
            short_content: shortContent,
            tags,
            published_at: publishDate
          } = post?.data ?? {}

          return (
            <div key={id}>
              <PostTile
                image={image}
                title={title}
                subtitle={shortContent}
                link={`/blog/post/${slug}`}
                tags={tags}
                date={publishDate}
              />
            </div>
          )
        })}
      </div>
    </Wrapper>
  )
}
